export default {
    App: {
        'Automation support': 'Automation support',
        'Browse stock equipment': 'Browse stock equipment',
        'Contact Kalmar': 'Contact Kalmar',
        'Create new': 'Create new',
        'Dealer community': 'Dealer community',
        'Download failed': 'Download failed',
        'Failed to get service reports': 'Failed to get service reports',
        'home': 'home',
        'Kalmar Care service request': 'Kalmar Care service request',
        'Kalmar Training Academy': 'Kalmar Training Academy',
        'Kalmar Used Equipment': 'Kalmar Used Equipment',
        'Loading MyKalmar': 'Loading MyKalmar',
        'Login again': 'Login again',
        'Maintenance reporting': 'Maintenance reporting',
        'Maintenance schedule': 'Maintenance schedule',
        'Manuals': 'Manuals',
        'My Cases': 'My Cases',
        'MyKalmar homepage': 'MyKalmar homepage',
        'MyParts': 'MyParts',
        'Navigating to MyParts failed': 'Navigating to MyParts failed',
        'No service reports found': 'No service reports found',
        'None': 'None',
        'Open Dealer community': 'Open Dealer community',
        'Open MyKalmar STORE': 'Open MyKalmar STORE',
        'Open MyKalmar INSIGHT': 'Open MyKalmar INSIGHT',
        'Open used equipment sales portal': 'Open used equipment sales portal',
        'Parts order history': 'Parts order history',
        'Read more and subscribe': 'Read more and subscribe',
        'Read more and register': 'Read more and register',
        'Register Kalmar equipment': 'Register Kalmar equipment',
        'Request training': 'Request training',
        'Request service': 'Request service',
        'Show all orders in MyParts': 'Show all orders in MyParts',
        'Show all ({{ equipmentLength }}) equipment': 'Show all ({{ equipmentLength }}) equipment',
        'Show all deliveries ({{ deliveryCount }})': 'Show all deliveries ({{ deliveryCount }})',
        'Show all Kalmar contacts': 'Show all Kalmar contacts',
        'Show all cases': 'Show all cases',
        'Show manuals search': 'Show manuals search',
        'Show on calendar': 'Show on calendar',
        'Show requests': 'Show requests',
        'Try again': 'Try again',
        'You are now logged out from MyKalmar': 'You are now logged out from MyKalmar',
        'Open TechSight': 'Open TechSight',
        'Solve smarter: your one-stop information source': 'Solve smarter: your one-stop information source',
    },
    BackToTop: {
        'Back to top': 'Back to top',
    },
    Banner: {
        'Boost driving skills and technical expertise with Kalmar Training Academy specialized training courses, designed to keep your team & equipment safe and reliable.': 'Boost driving skills and technical expertise with Kalmar Training Academy specialized training courses, designed to keep your team & equipment safe and reliable.',
        'Check details for your equipment until they last.': 'Check details for your equipment until they last.',
        'Discover how to get the most out of your equipment.': 'Discover how to get the most out of your equipment.',
        'Ensure uptime, optimize your operations, and much more.': 'Ensure uptime, optimise your operations, and much more.',
        'Explore Kalmar Services': 'Explore Kalmar Services',
        'FLASH Sale is now on - Save up to 70%': 'FLASH Sale is now on - Save up to 70%',
        'Go to STORE': 'Go to STORE',
        'Learn more': 'Learn more',
        'Register in STORE now': 'Register in STORE now',
        'Selected Kalmar Genuine Parts now discounted in the MyKalmar STORE Outlet.': 'Selected Kalmar Genuine Parts now discounted in the MyKalmar STORE Outlet.',
        'Take your team’s performance to the next level!': 'Take your team’s performance to the next level!',
    },
    BulletinsTab: {
        'Bulletins': 'Bulletins',
        'Product': 'Product',
        'Subject': 'Subject',
        'Date': 'Date',
        'Open pdf': 'Open pdf',
        'Search bulletins': 'Search bulletins',
        'Select equipment': 'Select equipment',
        'Category': 'Category',
        'Select category': 'Select category',
        'No bulletins for your fleet.': 'No bulletins for your fleet.',
        'Bulletins are currently available for select equipment types only. We are actively expanding coverage to include the rest of your fleet in upcoming updates.': 'Bulletins are currently available for select equipment types only. We are actively expanding coverage to include the rest of your fleet in upcoming updates.',
        'Bulletins are visible to Kalmar internal users only.': 'Bulletins are visible to Kalmar internal users only.',
    },
    Common: {
        'All': 'All',
        'Language': 'Language',
        'Select language': 'Select language',
        'Availability': 'Availability',
        'Call the number': 'Call the number',
        'called': 'Called',
        'Cancel': 'Cancel',
        'Close': 'Close',
        'completed': 'Completed',
        'Contracts': 'Contracts',
        'Customer number': 'Customer number',
        'declined': 'Declined',
        'Description': 'Description',
        'Details': 'Details',
        'Email': 'Email',
        'Home': 'Home',
        'Maintenance': 'Maintenance',
        'Monthly report': 'Monthly report',
        'Monthly': 'Monthly',
        'My Delivery': 'My Delivery',
        'My Equipment': 'My Equipment',
        'N/A': 'N/A',
        'Name': 'Name',
        'No data for this time period': 'No data for this time period',
        'No data': 'No data',
        'OK': 'OK',
        'ordered': 'Ordered',
        'Other': 'Other',
        'Other Equipment': 'Other Equipment',
        'Phone': 'Phone',
        'Stock equipment': 'Stock equipment',
        'Register Kalmar equipment': 'Register Kalmar equipment',
        'Request submission failed': 'Request submission failed',
        'Response Time': 'Response Time',
        'scheduled': 'Scheduled',
        'Search': 'Search',
        'See details': 'See details',
        'Send': 'Send',
        'Serial number': 'Serial number',
        'Show on page': 'Show on page',
        'Site': 'Site',
        'Something went wrong': 'Something went wrong',
        'Status': 'Status',
        'today': 'today',
        'Type': 'Type',
        'Unknown': 'Unknown',
        'User': 'User',
        'Yearly trend': 'Yearly trend',
        'Yearly': 'Yearly',
        'Welcome to MyKalmar': 'Welcome to MyKalmar',
        'Open': 'Open',
    },
    ContactWidget: {
        'Call the number': 'Call the number',
        'Contact us!': 'Contact us!',
        'Need help?  Or need to know more about our services?': 'Need help?  Or need to know more about our services?',
        'Send email': 'Send email',
    },
    CustomerSelector: {
        'No results found with': 'No results found with',
        'Search with name, city, street address or sold-to number': 'Search with name, city, street address or sold-to number',
        'Select customer': 'Select customer',
    },
    DataRequestForm: {
        'Acceptance of Data Notice': 'Acceptance of Data Notice',
        'Company name': 'Company name',
        'Contact us': 'Contact us',
        'Data Act Notice': 'Data Act Notice',
        'Data request sent': 'Data request sent',
        'Date of data concerned by the request': 'Date of Data concerned by the request',
        'Details': 'Details',
        'Error sending data request:': 'Error sending data request:',
        'Fill request form': 'Fill request form',
        'Form for data access request': 'Form for data access request',
        'I have read and agree to the': 'I have read and agree to the',
        'Name': 'Name',
        'No customer selected': 'No customer selected',
        'Open comments': 'Open comments',
        'Or alternatively,': 'Or alternatively,',
        'Position/relationship with the Company': 'Position/relationship with the Company',
        'Products concerned by the request (e.g. serial number)': 'Products concerned by the request (e.g. serial number)',
        'Something went wrong': 'Something went wrong',
        'Thank you for your data request': 'Thank you for your data request',
        'Past data': 'Past data',
        'Present data': 'Present data',
        'Required data': 'Required data',
        'Alternatively, please contact us at': 'Alternatively, please contact us at',
    },
    DealerCommunity: {
        'Sales & general information': 'Sales & general information',
        'Marketing & products': 'Marketing & products',
        'Technical library': 'Technical library',
        'News': 'News',
        'Kalmar contacts': 'Kalmar contacts',
    },
    DocumentationTab: {
        'Manuals': 'Manuals',
        'Manual': 'Manual',
        'Open': 'Open',
        'Select language': 'Select language',
        'See more manuals in other languages': 'See more manuals in other languages',
        'Search manuals with serial number': 'Search manuals with serial number',
    },
    EmptyWidgets: {
        'Buy genuine parts': 'Buy genuine parts',
        'By registering your equipment you can see manuals, contracts and more': 'By registering your equipment you can see manuals, contracts and more',
        'Create a case': 'Create a case',
        'Do you have an inquiry?': 'Do you have an inquiry?',
        'Description (serial numbers of all the equipment you want to register)': 'Description (serial numbers of all the equipment you want to register)',
        'Kalmar Services': 'Kalmar Services',
        'Phone number': 'Phone number',
        'Performance management tool for cargo handling operations': 'Performance management tool for cargo handling operations',
        'Registration request received': 'Registration request received',
        'Thank you for your registration request. We will handle your request as soon as possible.': 'Thank you for your registration request. We will handle your request as soon as possible.',
        'User': 'User',
    },
    EquipmentAvailability: {
        'Equipment type': 'Equipment type',
        'Month': 'Month',
        'No data for this time period': 'No data for this time period',
        'Quarter': 'Quarter',
        'See details': 'See details',
        'Year': 'Year',
    },
    EquipmentAvailabilityByType: {
        'No data for this time period': 'No data for this time period',
        'Time spent': 'Time spent',
    },
    Footer: {
        'General conditions': 'General conditions',
        'MyKalmar INSIGHT': 'MyKalmar INSIGHT',
        'Invoicing instructions': 'Invoicing instructions',
        'Kalmar in Social Media': 'Kalmar in Social Media',
        'Legal notice': 'Legal notice',
        'MyKalmar': 'MyKalmar',
        'MyKalmar STORE': 'MyKalmar STORE',
        'Postal address': 'Postal address',
        'Privacy policy': 'Privacy policy',
        'Sitemap': 'Sitemap',
        'Supplier pages': 'Supplier pages',
        'Street address': 'Street address',
        'Subscribe': 'Subscribe',
        'EU Data Act': 'EU Data Act',
        'For data questions, please contact': 'For data questions, please contact',
    },
    KalmarInsightWidget: {
        'equipment': 'equipment',
        'Expired license': 'Expired license',
        'License expiring soon': 'License expiring soon',
        'Manage users': 'Manage users',
        'Number of MyKalmar INSIGHT users': 'Number of MyKalmar INSIGHT users',
        'Valid license': 'Valid license',
    },
    LanguageSelector: {
        'Select language': 'Select language',
    },
    LoadingFailure: {
        'Loading cases failed': 'Loading cases failed',
        'Loading deliveries failed': 'Loading deliveries failed',
        'Loading equipment availability failed': 'Loading equipment availability failed',
        'Loading equipment failed': 'Loading equipment failed',
        'Loading failed': 'Loading failed',
        'Loading maintenance schedule failed': 'Loading maintenance schedule failed',
        'Loading preventive maintenance data failed': 'Loading preventive maintenance data failed',
        'Loading response time failed': 'Loading response time failed',
        'Loading sales orders failed': 'Loading sales orders failed',
        'Retry': 'Retry',
    },
    MaintenanceCalendar: {
        'Equipment name': 'Equipment name',
        'Maintenance description': 'Maintenance description',
        'No maintenance scheduled for the selected day.': 'No maintenance scheduled for the selected day.',
    },
    MaintenanceReporting: {
        'Equipment availability': 'Equipment availability',
        'Preventive maintenance': 'Preventive maintenance',
    },
    MaintenanceReportingWidget: {
        'Average duration from breakdown to the first service operation start': 'Average duration from breakdown to the first service operation start',
        'Average percentage the equipment was available': 'Average percentage the equipment was available',
        'Planned maintenance operations that were completed on time': 'Planned maintenance operations that were completed on time',
    },
    MaintenanceScheduleWidget: {
        'No upcoming maintenances': 'No upcoming maintenances',
        'Upcoming maintenances': 'Upcoming maintenances',
    },
    MasterHeader: {
        'Go to MyKalmar STORE or MyKalmar INSIGHT': 'Go to MyKalmar STORE or MyKalmar INSIGHT',
        'Language': 'Language',
        'Log out': 'Log out',
        'MyKalmar profile': 'MyKalmar profile',
        'You can go to MyKalmar STORE and MyKalmar INSIGHT by clicking here': 'You can go to MyKalmar STORE and MyKalmar INSIGHT by clicking here',
    },
    MyCasesWidget: {
        'An unknown value': 'An unknown value',
        'Automation': 'Automation',
        'Case': 'Case',
        'changed from': 'changed from',
        'Comment': 'Comment',
        'n/a': 'n/a',
        'New comment': 'New comment',
        'No recent updates to cases': 'No recent updates to cases',
        'Priority': 'Priority',
        'Recent updates': 'Recent updates',
        'Resolution_Date__c': 'Resolution date',
        'STORE': 'STORE',
        'to': 'to',
        'updated': 'updated',
        'Updated at': 'Updated at',
    },
    MyEquipment: {
        'Bulletin': 'Bulletin',
        'Bulletins': 'Bulletins',
        'Contracts': 'Contracts',
        'Documentation': 'Documentation',
        'Digital subscriptions': 'Digital subscriptions',
        'Equipment details': 'Equipment details',
        'Equipment name': 'Equipment name',
        'MyKalmar INSIGHT': 'MyKalmar INSIGHT',
        'Leasing': 'Leasing',
        'Model': 'Model',
        'Search equipment with name, serial number, description, model or site...': 'Search equipment with name, serial number, description, model or site...',
        'Search with name, serial number or description': 'Search with name, serial number or type',
        'Short-term rental': 'Short-term rental',
    },
    MyEquipmentItem: {
        'Contract ends': 'Contract ends',
        'Contract started': 'Contract started',
        'Equipment details': 'Equipment details',
        'insight': 'MyKalmar INSIGHT',
        'leasing': 'Leasing',
        'Machine card': 'Machine card',
        'maintenance': 'Maintenance',
        'Maintenance schedule': 'Maintenance schedule',
        'Manufacturing year': 'Manufacturing year',
        'Model': 'Model',
        'No data': 'No data',
        'No contracts': 'No contracts',
        'Contact Kalmar for signing a contract': 'Contact Kalmar for signing a contract',
        'No equipment found': 'No equipment found',
        'Open': 'Open',
        'Order parts': 'Order parts',
        'Owner': 'Owner',
        'rental-short-term': 'Short-term rental',
        'Running hours': 'Running hours',
        'See Insights': 'See Insights',
        'Today': 'Today',
        'Preventive maintenance reports': 'Preventive maintenance reports',
        'No preventive maintenance reports': 'No preventive maintenance reports',
        'Preventive maintenance reports are generated after certified Kalmar service inspections. Book a service inspection with our local team to keep your equipment running reliably.':
            'Preventive maintenance reports are generated after certified Kalmar service inspections. Book a service inspection with our local team to keep your equipment running reliably.',
        'Learn more about Kalmar maintenance': 'Learn more about Kalmar maintenance',
        'Learn more about Kalmar Care': 'Learn more about Kalmar Care',
        'Maintenance records are temporarily unavailable': 'Maintenance records are temporarily unavailable',
        'Service order': 'Service order',
        'Maintenance interval': 'Maintenance interval',
        'Date': 'Date',
        'Faults': 'Faults',
        'Comments': 'Comments',
        'View comments': 'View comments',
        'Open pdf': 'Open pdf',
        'Chapter': 'Chapter',
        'Checkpoint': 'Checkpoint',
        'Comment': 'Comment',
    },
    MyEquipmentWidget: {},
    MyPartsWidget: {
        'At warehouse': 'At warehouse',
        'Customer PO': 'Customer PO',
        'Delivered': 'Delivered',
        'Est. Delivery': 'Est. Delivery',
        'Hide tracking': 'Hide tracking',
        'My last parts orders': 'My last parts orders',
        'No orders': 'No orders',
        'Note: this order will be delivered in multiple shipments.': 'Note: This order will be delivered in multiple shipments.',
        'Order number': 'Order number',
        'Order received': 'Order received',
        'Processing': 'Processing',
        'Shipment': 'Shipment',
        'Shipped': 'Shipped',
        'Tracking': 'Tracking',
        'View tracking': 'View tracking',
        'Tracking information not available at the moment': 'Tracking information not available at the moment',
        'Not available': 'Not available',
        'Please wait for tracking information...': 'Please wait for tracking information...',
    },
    NotFound: {
        'Go to home page': 'Go to home page',
        'Page not found': 'Page not found',
        'The page may have been moved or you may not have the necessary rights to access this page': 'The page may have been moved or you may not have the necessary rights to access this page',
    },
    PaginationTable: {
        "itemsCurrentlyShownText": "{{shownItemAmount}} of {{maxItemAmount}} shown"
    },
    PreventiveMaintenanceCompletion: {
        'completed in': 'completed in',
        'Count': 'Count',
        'No data for': 'No data for',
        'Not completed': 'Not completed',
        'Percentage': 'Percentage',
        'Planned': 'Planned',
        'tasks': 'tasks',
    },
    ResponseTime: {
        'Action started': 'Action started',
        'avg. response time': 'avg. response time',
        'Call started': 'Call started',
        'in': 'in',
        'Operation': 'Operation',
        'Response time': 'Response time',
    },
    ServiceRequests: {
        'Breakdown Maintenance': 'Breakdown Maintenance',
        'Closed': 'Closed',
        'Corrective Maintenance': 'Corrective Maintenance',
        'Created': 'Created',
        'Create new': 'Create new',
        'Customer name': 'Customer name',
        'Enter detailed description of the maintenance request...': 'Enter detailed description of the maintenance request...',
        'expertise, or swift troubleshooting.': 'expertise, or swift troubleshooting.',
        'Fill request form': 'Fill request form',
        'Maintenance type': 'Maintenance type',
        'Mark request as complete': 'Mark request as complete',
        'No customer selected': 'No customer selected',
        'No service requests': 'No service requests',
        'Other Maintenance': 'Other Maintenance',
        'Request received': 'Request received',
        'Request urgent repairs, additional maintenance': 'Request urgent repairs, additional maintenance',
        'Phone number': 'Phone number',
        'Preferred maintenance date (Kalmar cannot guarantee maintenance on this date)': 'Preferred maintenance date (Kalmar cannot guarantee maintenance on this date)',
        'Preventive Maintenance': 'Preventive Maintenance',
        'Search request': 'Search request',
        'Equipment location': 'Equipment location',
        "This can't be changed": "This can't be changed",
        'Thank you for your service request. We will contact you by phone as soon as possible during business hours.': 'Thank you for your service request. We will contact you by phone as soon as possible during business hours.',
        'Training type': 'Training type',
        'User': 'User',
        'Your reference': 'Your reference',
    },
    SessionExpirationModal: {
        'Log in again': 'Log in again',
        'You have been logged out due to inactivity': 'You have been logged out due to inactivity',
        'Your session has expired': 'Your session has expired',
    },
    SiteSelector: {
        'Customer': 'Customer',
        'No sites with equipment': 'No sites with equipment',
        'Select a customer': 'Select a customer',
        'Selected': 'Selected',
        'Show all sites': 'Show all sites',
        'Showing all sites': 'Showing all sites',
        'Recently visited': 'Recently visited',
    },
    StockEquipment: {
        'Price': 'Price',
        'Currency': 'Currency',
        'Please select a currency for the price': 'Please select a currency for the price',
        'Contact email': 'Contact email',
        'Added': 'Added',
        'All': 'All',
        'Cancel': 'Cancel',
        'Close': 'Close',
        'Configuration number': 'Configuration number',
        'Confirm': 'Confirm',
        'Create stock equipment': 'Create stock equipment',
        'Datasheet': 'Datasheet',
        'Datasheets': 'Datasheets',
        'Delete': 'Delete',
        'Delete this equipment. This action can’t be undone.': 'Delete this equipment. This action can’t be undone',
        'Description': 'Description',
        'Details': 'Details',
        'Documents': 'Documents',
        'Edit': 'Edit',
        'Engine type': 'Engine type',
        'Equipment added successfully': 'Equipment added successfully',
        'Equipment adding failed': 'Equipment adding failed',
        'Estimated availability': 'Estimated availability',
        'If you are interested in this equipment, please contact your local Kalmar sales representative or email us at': 'If you are interested in this equipment, please contact your local Kalmar sales representative or email us at',
        'Manufacturing year': 'Manufacturing year',
        'MAU location': 'MAU location',
        'Mark as active': 'Mark as active',
        'Mark as inactive': 'Mark as inactive',
        'Mark as reserved': 'Mark as reserved',
        'Mark as sold': 'Mark as sold',
        'Cancel reservation': 'Cancel reservation',
        'Copy and create new': 'Copy and create new',
        'More options': 'More options',
        'ACTIVE': 'Active',
        'INACTIVE': 'Inactive',
        'RESERVED': 'Reserved',
        'SOLD': 'Sold',
        'Mark equipment as sold. This action can’t be undone.': 'Mark equipment as sold. This action can’t be undone.',
        'Model': 'Model',
        'No equipment found': 'No equipment found',
        'Other Equipment': 'Other Equipment',
        'Picture': 'Picture',
        'Pictures': 'Pictures',
        'Ready': 'Ready',
        'Region': 'Region',
        'Regions': 'Regions',
        'Search equipment with name, serial number, description, model or site...': 'Search equipment with name, serial number, description, model or site...',
        'Search with name, serial number or description': 'Search with name, serial number or description',
        'See all stock equipment ready to deliver': 'See all stock equipment ready to deliver',
        'Select equipment type': 'Select equipment type',
        'Select region': 'Select region',
        'Send': 'Send',
        'Show on page': 'Show on page',
        'Something went wrong': 'Something went wrong',
        'Specification': 'Specification',
        'Specifications': 'Specifications',
        'Stock equipment details': 'Stock equipment details',
        'Type': 'Type',
        'Upload': 'Upload',
        'Picture is too large. Please upload a picture smaller than 8 MB.': 'Picture is too large. Please upload a picture smaller than 8 MB.',
        'Contact': 'Contact',
        'Stock equipment': 'Stock equipment',
        'Show more': 'Show more',
        'Show less': 'Show less',
    },
    TimeUnitLinks: {
        'Show': 'Show',
    },
    Tooltips: {
        'Content': 'Content',
        'Recent reports': 'Recent reports',
    },
    TrainingRequests: {
        'All': 'All',
        'Closed': 'Closed',
        'Created': 'Created',
        'Create new': 'Create new',
        'Customer name': 'Customer name',
        'Eco Driving Training': 'Eco Driving Training',
        'Enter detailed description of the training request...': 'Enter detailed description of the training request...',
        'Number of participants': 'Number of participants',
        'Operator Training': 'Operator Training',
        'Phone number': 'Phone number',
        'Preferred time frame for training (Kalmar can’t guarantee training during this time frame, the training is reserved only after Kalmar has contacted you)': 'Preferred time frame for training (Kalmar can’t guarantee training during this time frame, the training is reserved only after Kalmar has contacted you)',
        'Product Training': 'Product Training',
        'Reach out to one of our training specialists today.': 'Reach out to one of our training specialists today.',
        'Receive hands-on training with heavy equipment and jobsite skills from industry professionals.': 'Receive hands-on training with heavy equipment and jobsite skills from industry professionals.',
        'Request received': 'Request received',
        'Search training': 'Search training',
        'Show requests': 'Show requests',
        'Technical Training': 'Technical Training',
        'Thank you for your training request. We will contact you by phone as soon as possible during business hours.': 'Thank you for your training request. We will contact you by phone as soon as possible during business hours.',
        'Training type': 'Training type',
    },
};
